// Permissões - CAIXA MESTRE
// Admin: acesso total
// Almoxarife: tudo exceto configurações
// Comprador: apenas Compras, Estoque e Sobre

export const PERFIS = {
  admin: 'admin',
  almoxarife: 'almoxarife',
  comprador: 'comprador'
}

// ========== ADMIN: Acesso total ==========
// ========== ALMOXARIFE: Tudo exceto configurações ==========
// ========== COMPRADOR: Apenas Compras, Estoque e Sobre ==========

export function canManageUsers(perfil) {
  return perfil === PERFIS.admin
}

export function canAccessSettings(perfil) {
  // Apenas admin acessa configurações
  return perfil === PERFIS.admin
}

export function canMoveStock(perfil) {
  // Admin e almoxarife podem movimentar estoque
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife
}

export function canEditCatalog(perfil) {
  // Admin e almoxarife podem editar catálogo
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife
}

export function canViewCatalog(perfil) {
  // Admin, almoxarife e comprador podem ver catálogo
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife || perfil === PERFIS.comprador
}

export function canViewReports(perfil) {
  // Apenas admin e almoxarife podem ver relatórios
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife
}

// ========== COMpras ==========
export function canAccessCompras(perfil) {
  // Comprador, admin e almoxarife acessam compras
  return perfil === PERFIS.comprador || perfil === PERFIS.admin || perfil === PERFIS.almoxarife
}

export function canConfirmCompras(perfil) {
  // Comprador e admin confirmam compras
  return perfil === PERFIS.comprador || perfil === PERFIS.admin
}

export function canViewHistoricoCompras(perfil) {
  // Comprador, admin e almoxarife veem histórico
  return perfil === PERFIS.comprador || perfil === PERFIS.admin || perfil === PERFIS.almoxarife
}

export function canCreatePedidos(perfil) {
  // Admin, almoxarife e comprador criam pedidos
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife || perfil === PERFIS.comprador
}

export function canViewEstoque(perfil) {
  // Comprador precisa ver estoque
  return perfil === PERFIS.admin || perfil === PERFIS.almoxarife || perfil === PERFIS.comprador
}

// ========== Navegação por perfil ==========
export function getMenuByProfile(perfil) {
  const allMenus = [
    { id: 'dashboard', label: 'Dashboard', icon: 'home', path: '/' },
    { id: 'estoque', label: 'Estoque', icon: 'package', path: '/estoque' },
    { id: 'compras', label: 'Compras', icon: 'shopping-cart', path: '/compras' },
    { id: 'historico-compras', label: 'Histórico', icon: 'history', path: '/historico-compras' },
    { id: 'funcionarios', label: 'Funcionários', icon: 'users', path: '/funcionarios' },
    { id: 'pedidos', label: 'Pedidos', icon: 'clipboard-list', path: '/pedidos' },
    { id: 'entregas', label: 'Entregas', icon: 'truck', path: '/entregas' },
    { id: 'relatorios', label: 'Relatórios', icon: 'bar-chart', path: '/relatorios' },
    { id: 'configuracoes', label: 'Configurações', icon: 'settings', path: '/configuracoes' },
    { id: 'sobre', label: 'Sobre', icon: 'info', path: '/sobre' }
  ]

  switch (perfil) {
    case PERFIS.admin:
      // Admin: acesso total
      return allMenus
    
    case PERFIS.almoxarife:
      // Almoxarife: tudo exceto configurações
      return allMenus.filter(m => m.id !== 'configuracoes')
    
    case PERFIS.comprador:
      // Comprador: apenas Compras, Estoque e Sobre
      return [
        { id: 'compras', label: 'Compras', icon: 'shopping-cart', path: '/compras' },
        { id: 'estoque', label: 'Estoque', icon: 'package', path: '/estoque' },
        { id: 'sobre', label: 'Sobre', icon: 'info', path: '/sobre' }
      ]
    
    default:
      return [{ id: 'sobre', label: 'Sobre', icon: 'info', path: '/sobre' }]
  }
}

